import { Button, Col, Popconfirm, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { blogTabConfig } from '../BlogsTab';
import { useDispatch, useSelector } from 'react-redux';
import { setBlogs, setBlog, deleteBlog } from '../../../store/slices/blogSlice';
import SearchComponent from '../../../components/SearchComponent';
import { DeleteOutlined } from '@ant-design/icons';


function BlogList({ onSwitchTab }) {
    const dataFetcher = useSWR({ method: GET, url: API_ROUTE + '/blogs' }, fetcher);
    const state = useSelector(state => state.blogSlice);
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);

    const edit = (data) => {
        dispatch(setBlog(data))
        onSwitchTab(blogTabConfig.ADD, data);
    }

    const deleteData = (data) => {
        console.log(data)
        dispatch(deleteBlog({ blogId: data.id, data }))
    }

    useEffect(() => {
        if (dataFetcher.data?.data) {
            dispatch(setBlogs(dataFetcher.data.data));
        }
    }, [dataFetcher.data?.data])

    const columns = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <>
                    <div>
                        <Button onClick={() => edit(record)}>Amend</Button>
                        <Popconfirm
                            title="Delete Data"
                            description="Are you sure to delete this record?"
                            onConfirm={() => deleteData(record)}
                            okButtonProps={{ danger: true }}
                            okText="Yes"
                            cancelText="No"
                        >
                            <DeleteOutlined className='p-4' />
                        </Popconfirm>
                    </div>
                </>
            )
        }
    ];

    const onFilter = (filteredData) => {
        setFilteredData(filteredData);
    }

    return (
        <Row gutter={[16, 16]}>
            <SearchComponent masterData={state.blogList} onFilter={onFilter} filterByKeys={['title', 'description', 'status']} />
            <Col span={24}>
                <Table columns={columns} dataSource={filteredData} pagination={false} loading={dataFetcher.isLoading} />
            </Col>
        </Row>
    );
}

export default BlogList